import React from 'react';
import {Link} from "react-router-dom";
import {Button, Icon} from "@gravity-ui/uikit"
import {ArrowUpRightFromSquare} from "@gravity-ui/icons";


import './ProjectCard.css'
import {
    ProjectForSchool, ProjectPersona, ProjectVenue, ProjectDate, ProjectKeywords, ProjectStatusSelect, ProjectStream
} from "./utils";
import {EditButtonIcon_Link} from "../Button/Button";

function ProjectReviewCard({children, project}) {
    return (
        <div className="bmm-card project-card project-card-draft">
            <div className="project-card__pretitle mb-1">
                <div>
                    {project.customers?.length > 0 && project.customers.map((customer, index) => (
                        <ProjectPersona key={index} user={customer}/>
                    ))}
                </div>
                <ProjectStatusSelect project={project}/>
            </div>

            <div className="project-card__pretitle">
                <div className={"me-1"}>
                    <ProjectVenue venue={project.venue}/>
                    <ProjectStream stream={project.local_stream}/>
                </div>
                <div>
                    <ProjectForSchool is_for_schoolchildren={project.is_for_schoolchildren}/>
                </div>
            </div>

            <Link to={`${project.id}`} className="project-card__title">{project.name}</Link>

            <div className="project__keywords project-card__keywords">
                <ProjectKeywords keywords={project.keywords}/>
            </div>

            <div className="project-card__text" dangerouslySetInnerHTML={{__html: project.description}}/>

            {project.managers?.length > 0 && project.managers.map((manager, index) => (
                <ProjectPersona key={index} user={manager}/>
            ))}

            <div className="project-card__subtitle">
                <div className="project-card__subtitle-date">
                    <ProjectDate date={new Date(project.created_on)}/>
                </div>
                <div className="group-btn">
                    <Link to={`/project/${project.id}`}>
                        <Button view={"normal"} size={"m"} title={"Предпросмотр"}>
                            <Icon data={ArrowUpRightFromSquare} size={18}/>
                        </Button>
                    </Link>
                    <EditButtonIcon_Link to={`${project.id}`}/>
                </div>
            </div>
        </div>);
}

export default ProjectReviewCard;